var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.datetime)?_c('v-app-bar-title',{attrs:{"id":"clock"}},[_vm._v(" "+_vm._s(_vm.datetime)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }